import { INotificationType } from 'src/types/helpdesk/notificationType';

// const result = localStorage.getItem('userInfo');
// const userInfo: UserInfo = result ? JSON.parse(result) : null;

// FIXME: Cần sửa lại thông báo khi bấm vào xem thông báo sẽ dẫn đến trang nào
export const NOTIFICATION_TYPE: INotificationType[] = [
  //#region TICKET
  {
    key: 'TKA',
    title: 'Ticket - Phê duyệt',
    queryFn: 'tickets',
    // returnUrl: urlPath.approval.location
    returnUrl: '*'
  },
  {
    key: 'TKAR',
    title: 'Ticket - Từ chối',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  {
    key: 'TKC',
    title: 'Ticket - Xác nhận',
    queryFn: 'tickets',
    // returnUrl: urlPath.accept.location
    returnUrl: '*'
  },
  {
    key: 'TKCR',
    title: 'Ticket - Từ chối xác nhận',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  {
    key: 'TKH',
    title: 'Ticket - Xử lý',
    queryFn: 'tickets',
    // returnUrl: urlPath.solution.location
    returnUrl: '*'
  },
  {
    key: 'TKAS',
    title: 'Ticket - Phân công xử lý',
    queryFn: 'tickets',
    // returnUrl: urlPath.handle.location
    returnUrl: '*'
  },
  {
    key: 'TKAD',
    title: 'Ticket - Phê duyệt',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  {
    key: 'TKD',
    title: 'Ticket - Hoàn thành',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  {
    key: 'CANCEL_APPROVAL',
    title: 'Ticket - Thu hồi duyệt',
    queryFn: 'tickets',
    // returnUrl: urlPath.approval.location
    returnUrl: '*'
  },
  {
    key: 'TKSC',
    title: 'Ticket - Từ chối giải pháp',
    queryFn: 'tickets',
    // returnUrl: urlPath.solution.location
    returnUrl: '*'
  },
  {
    key: 'TKSAD',
    title: 'Ticket - Duyệt giải pháp',
    queryFn: 'tickets',
    // returnUrl: urlPath.solution.location
    returnUrl: '*'
  },
  {
    key: 'TKSAA',
    title: 'Ticket - Duyệt giải pháp',
    queryFn: 'tickets',
    // returnUrl: urlPath.solution.location
    returnUrl: '*'
  },
  {
    key: 'TKNC',
    title: 'Ticket - Đồng ý kết quả xử lý',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  {
    key: 'TKRC',
    title: 'Ticket - Không đồng ý kết quả xử lý',
    queryFn: 'tickets',
    // returnUrl: urlPath.solution.location
    returnUrl: '*'
  },
  {
    key: 'TICKET_OWNER_OT',
    title: 'Tăng ca - Xác nhận tăng ca',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  {
    key: 'TICKET_OWNER_BUS',
    title: 'Ticket - Xác nhận công tác',
    queryFn: 'tickets',
    // returnUrl: urlPath.myTicket.location
    returnUrl: '*'
  },
  //#endregion TICKET

  //#region TOPIC
  {
    key: 'TOPIC_TAG',
    title: 'Ban được nhắc đến trong tin nhắn',
    queryFn: 'topics',
    // returnUrl: urlPath.topic.location
    returnUrl: '*'
  },
  {
    key: 'TOPIC_MESSAGE',
    title: 'Tin nhắn mới',
    queryFn: 'topics',
    // returnUrl: urlPath.topic.location
    returnUrl: '*'
  },
  //#endregion

  //#region RESIGNATION
  {
    key: 'RESIGNATION_APPROVAL',
    title: 'Nghỉ việc - Phê duyệt',
    queryFn: 'resignationTickets',
    // returnUrl: urlPath.resignationTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'RESIGNATION_APPROVED',
    title: 'Nghỉ việc - Phê duyệt',
    queryFn: 'resignationTickets',
    // returnUrl: urlPath.myResignationTicket.location
    returnUrl: '*'
  },
  {
    key: 'RESIGNATION_REJECTED',
    title: 'Nghỉ việc - Từ chối',
    queryFn: 'resignationTickets',
    // returnUrl: urlPath.myResignationTicket.location
    returnUrl: '*'
  },
  {
    key: 'RESIGNATION_CANCELLED_APPROVAL',
    title: 'Nghỉ việc - Thu hồi duyệt',
    queryFn: 'resignationTickets',
    // returnUrl: urlPath.resignationTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region LEAVE
  {
    key: 'LEAVE_APPROVAL',
    title: 'Nghỉ phép - Phê duyệt',
    queryFn: 'leaveTicketsV2',
    // returnUrl: urlPath.leaveTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'LEAVE_APPROVED',
    title: 'Nghỉ phép - Phê duyệt',
    queryFn: 'leaveTicketsV2',
    // returnUrl: urlPath.myLeaveTicket.location
    returnUrl: '*'
  },
  {
    key: 'LEAVE_REJECTED',
    title: 'Nghỉ phép - Từ chối',
    queryFn: 'leaveTicketsV2',
    // returnUrl: urlPath.myLeaveTicket.location
    returnUrl: '*'
  },
  {
    key: 'LEAVE_CANCELLED_APPROVAL',
    title: 'Nghỉ phép - Thu hồi duyệt',
    queryFn: 'leaveTicketsV2',
    // returnUrl: urlPath.leaveTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'LEAVE_CANCELLED',
    title: 'Nghỉ phép - Hủy phiếu',
    queryFn: 'leaveTicketsV2',
    // returnUrl: urlPath.leaveTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region LEAVE PACKAGE
  {
    key: 'LEAVE_PACKAGE_APPROVAL',
    title: 'Nghỉ phép - Phê duyệt',
    queryFn: 'leaveTicketPackagesV2',
    // returnUrl: urlPath.leaveTicketPackageApproval.location
    returnUrl: '*'
  },
  {
    key: 'LEAVE_PACKAGE_CANCELLED_APPROVAL',
    title: 'Nghỉ phép - Thu hồi duyệt',
    queryFn: 'leaveTicketPackagesV2',
    // returnUrl: urlPath.leaveTicketPackageApproval.location
    returnUrl: '*'
  },
  {
    key: 'LEAVE_PACKAGE_CANCELLED',
    title: 'Nghỉ phép - Hủy phiếu',
    queryFn: 'leaveTicketPackagesV2',
    // returnUrl: urlPath.leaveTicketPackageApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region OT
  {
    key: 'OT_APPROVAL',
    title: 'Tăng ca - Phê duyệt',
    queryFn: 'overtimeTicketsV2',
    // returnUrl: urlPath.overtimeTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'OT_APPROVED',
    title: 'Tăng ca - Phê duyệt',
    queryFn: 'overtimeTicketsV2',
    // returnUrl: urlPath.myOvertimeTicket.location
    returnUrl: '*'
  },
  {
    key: 'OT_SUPERVISOR_CONFIRM',
    title: 'Tăng ca - Giám sát xác nhận',
    queryFn: 'overtimeTicketsV2',
    // returnUrl: urlPath.overtimeTicketSupervisorConfirm.location
    returnUrl: '*'
  },
  {
    key: 'OT_REJECTED',
    title: 'Tăng ca - Từ chối',
    queryFn: 'overtimeTicketsV2',
    // returnUrl: urlPath.myOvertimeTicket.location
    returnUrl: '*'
  },
  {
    key: 'OT_CANCELLED_APPROVAL',
    title: 'Tăng ca - Thu hồi duyệt',
    queryFn: 'overtimeTicketsV2',
    // returnUrl: urlPath.overtimeTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region BUSINESS TRIP
  {
    key: 'TRIP_APPROVAL',
    title: 'Công tác - Phê duyệt',
    queryFn: 'businessTripTicketsV2',
    // returnUrl: urlPath.businessTripTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'TRIP_APPROVED',
    title: 'Công tác - Phê duyệt',
    queryFn: 'businessTripTicketsV2',
    // returnUrl: urlPath.myBusinessTripTicket.location
    returnUrl: '*'
  },
  {
    key: 'TRIP_REJECTED',
    title: 'Công tác - Từ chối',
    queryFn: 'businessTripTicketsV2',
    // returnUrl: urlPath.myBusinessTripTicket.location
    returnUrl: '*'
  },
  {
    key: 'TRIP_CANCELLED_APPROVAL',
    title: 'Công tác - Thu hồi duyệt',
    queryFn: 'businessTripTicketsV2',
    // returnUrl: urlPath.businessTripTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region TRANSPORTATION TICKET
  {
    key: 'TRAN_APPROVAL', // Gửi thông báo cho người phê duyệt
    title: 'Vận chuyển - Phê duyệt',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.transportationTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'TRAN_APPROVED', // Gửi thông báo đã phê duyệt cho người tạo phiếu
    title: 'Vận chuyển - Phê duyệt',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.myTransportationTicket.location
    returnUrl: '*'
  },
  {
    key: 'TRAN_REJECTED',
    title: 'Vận chuyển - Từ chối',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.myTransportationTicket.location
    returnUrl: '*'
  },
  {
    key: 'TRAN_CANCELLED_APPROVAL', // Gửi thông báo đã xác nhận cho người tạo phiếu
    title: 'Vận chuyển - Thu hồi duyệt',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.transportationTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'TRAN_CONFIRM', // Gửi thông báo cho người xác nhận
    title: 'Vận chuyển - Xác nhận',
    queryFn: 'transportationTicket',
    // returnUrl:
    // userInfo?.departmentId === DepartmentEn.hr
    //   ? urlPath.hrConfirmTransportationTicket.location
    //   : urlPath.transportationTicketConfirm.location
    returnUrl: '*'
  },
  {
    key: 'TRAN_CONFIRMED', // Gửi thông báo đã xác nhận cho người tạo phiếu
    title: 'Vận chuyển - Xác nhận',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.myTransportationTicket.location
    returnUrl: '*'
  },
  {
    key: 'TRAN_REJECT_CONFIRM', // Gửi thông báo đã từ chối xác nhận cho người tạo phiếu
    title: 'Vận chuyển - Xác nhận',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.myTransportationTicket.location
    returnUrl: '*'
  },
  {
    key: 'DRIVER_CONFIRMED', // Gửi thông báo cho tài xế
    title: 'Vận chuyển - Tài xế xử lý',
    queryFn: 'transportationTicket',
    // returnUrl: urlPath.transportationTicketHandle.location
    returnUrl: '*'
  },
  //#endregion

  //#region PURCHASE REQUEST TICKET
  {
    key: 'PR_APPROVAL',
    title: 'Mua hàng - Phê duyệt',
    queryFn: 'purchaseRequestTicketsV2',
    // returnUrl: urlPath.purchaseRequestTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'PR_APPROVED',
    title: 'Mua hàng - Phê duyệt',
    queryFn: 'purchaseRequestTicketsV2',
    // returnUrl: urlPath.myPurchaseRequestTicket.location
    returnUrl: '*'
  },
  {
    key: 'PR_REJECTED',
    title: 'Mua hàng - Từ chối',
    queryFn: 'purchaseRequestTicketsV2',
    // returnUrl: urlPath.myPurchaseRequestTicket.location
    returnUrl: '*'
  },
  {
    key: 'PR_CANCELLED_APPROVAL',
    title: 'Mua hàng - Thu hồi duyệt',
    queryFn: 'purchaseRequestTicketsV2',
    // returnUrl: urlPath.purchaseRequestTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region ADVANCE PAYMENT TICKET
  {
    key: 'AP_APPROVAL',
    title: 'Ứng tiền - Phê duyệt',
    queryFn: 'advancePaymentTickets',
    // returnUrl: urlPath.advancePaymentTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'AP_APPROVED',
    title: 'Ứng tiền - Phê duyệt',
    queryFn: 'advancePaymentTickets',
    // returnUrl: urlPath.myAdvancePaymentTicket.location
    returnUrl: '*'
  },
  {
    key: 'AP_REJECTED',
    title: 'Ứng tiền - Từ chối',
    queryFn: 'advancePaymentTickets',
    // returnUrl: urlPath.myAdvancePaymentTicket.location
    returnUrl: '*'
  },
  {
    key: 'AP_CANCELLED_APPROVAL',
    title: 'Ứng tiền - Thu hồi duyệt',
    queryFn: 'advancePaymentTickets',
    // returnUrl: urlPath.advancePaymentTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region HAND OVER TICKET
  {
    key: 'HANDOVER_CONFIRM',
    title: 'Bàn giao - Phê duyệt',
    queryFn: 'handOverTicketsV2',
    // returnUrl: urlPath.myHandoverTicket.location
    returnUrl: '*'
  },
  {
    key: 'HANDOVER_FINISHED',
    title: 'Ứng tiền - Xác nhận',
    queryFn: 'handOverTicketsV2',
    // returnUrl: urlPath.myHandoverTicket.location
    returnUrl: '*'
  },
  {
    key: 'HANDOVER_CANCELED',
    title: 'Ứng tiền - Hủy xác nhận',
    queryFn: 'handOverTicketsV2',
    // returnUrl: urlPath.handoverTicketApproval.location
    returnUrl: '*'
  },
  //#endregion

  //#region EQUIPMENT SUPPLY REQUEST TICKET
  {
    key: 'ESR_APPROVAL',
    title: 'Cấp thiết bị - Phê duyệt',
    queryFn: 'equipmentSupplyRequestTicketsV2',
    // returnUrl: urlPath.equipmentSupplyRequestTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'ESR_APPROVED',
    title: 'Cấp thiết bị - Phê duyệt',
    queryFn: 'equipmentSupplyRequestTicketsV2',
    // returnUrl: urlPath.myEquipmentSupplyRequestTicket.location
    returnUrl: '*'
  },
  {
    key: 'ESR_REJECTED',
    title: 'Cấp thiết bị - Từ chối',
    queryFn: 'equipmentSupplyRequestTicketsV2',
    // returnUrl: urlPath.myEquipmentSupplyRequestTicket.location
    returnUrl: '*'
  },
  {
    key: 'ESR_CANCELLED_APPROVAL',
    title: 'Cấp thiết bị - Thu hồi duyệt',
    queryFn: 'equipmentSupplyRequestTicketsV2',
    // returnUrl: urlPath.equipmentSupplyRequestTicketApproval.location
    returnUrl: '*'
  },
  {
    key: 'ESR_CANCELLED',
    title: 'Cấp thiết bị - Hủy phiếu',
    queryFn: 'equipmentSupplyRequestTicketsV2',
    // returnUrl: urlPath.equipmentSupplyRequestTicketApproval.location
    returnUrl: '*'
  }
  //#endregion
];
